import { ResourceProps } from "@refinedev/core";
import { BarChartOutlined, MessageOutlined } from "@ant-design/icons";

export const statsPushesResource: ResourceProps = {
  name: "statsPushes",
  meta: {
    icon: <MessageOutlined />,
    label: "Статистика пушей",
  },
  list: "/statsPushes",
};

export const pushAnalyticsResource: ResourceProps = {
  name: "pushAnalytics",
  meta: {
    icon: <BarChartOutlined />,
    label: "Аналитика пушей",
  },
  list: "/pushAnalytics",
};
